/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, displayTypes, mediaQuery, embedCorners } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// CONTENT STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	content: {
		extend: embedCorners, // late design addition to differentiate the unit from an ad
		flex: '1',
		height: '100%',
		width: '100%',
		position: 'absolute', // need to work in tandem with flex stuff
		top: '0',
		left: '0',
		opacity: '0',
		// dynamically generated classes based on content id contain widths and heights (since they are recalculated based on injectable)
		// '&.quiz': { backgroundColor: '#fc3' },
		// '&.poll': { backgroundColor: '#d3b' },
		// '&.story': { backgroundColor: '#5c1' },
		// '&.message': { backgroundColor: '#bb1' },
		// '&.result': { backgroundColor: '#a9e' },

		// pull in display type styles
		'&.inline': { extend: displayTypes.inline },
		'&.overlay': {
			extend: displayTypes.overlay,
			'&.splash': { zIndex: '4' },
            '&.ad': { zIndex: '4' }
		},
		'&:not(.overlay)': { transition: 'all .5s ease-out 0s' },

		// active vs innactive state
		'&.inactive': {
			zIndex: '-1 !important'
		},
		'&.active': {
			zIndex: '1',
			opacity: '1',
			transitionTimingFunction: 'ease-in'
		}
	},
	inner: {
		color: '#fff',
		height: '100%',
		width: '100%',
		overflow: 'hidden',
		position: 'relative',
		borderRadius: 'inherit', // late design addition to differentiate the unit from an ad
		'& .uniquecontent': {
			width: '100%',
			height: '100%',
			position: 'relative',
		}
	},
	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.wide]: hasRewardsComponent => ({
		inner: { fontSize: hasRewardsComponent ? '100%' : '115%' }
	}),
	[mediaQuery.medium]: hasRewardsComponent => ({
		inner: { fontSize: hasRewardsComponent ? '100%' : '105%' }
	}),
	[mediaQuery.thin]: {
		inner: { fontSize: '90%' }
	},
	[mediaQuery.short]: {
		inner: { fontSize: '90%' }
	},
	[mediaQuery.shorter]: {
		inner: { fontSize: '86%' }
	},
	[mediaQuery.shortest]: {
		inner: { fontSize: '82%' }
	}
};
